module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Cugy_neu-42f34c8cd1b5e03274a8d6cfc796bdd9.png";